import axios from 'axios'

const API_URL = `${process.env.REACT_APP_API_URL}`

const QM = {
  uploadWeights(data) {
    return axios({
      method: 'post',
      url: `${API_URL}/upload_weights`,
      data: data,
    })
  },
}

export default QM
